import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, CircularProgress, Alert,
} from '@mui/material';
import DOMPurify from 'dompurify';
import { useLegalAcceptance } from '../../contexts/LegalAcceptanceContext';

// A „Később” csak erre a böngésző-munkamenetre halasztja az ablakot (dokumentumonként),
// különben minden oldalbetöltéskor újra feljönne
const dismissKey = (docId) => `termsModalDismissed:${docId}`;
const wasDismissed = (docId) => {
  try { return sessionStorage.getItem(dismissKey(docId)) === '1'; } catch { return false; }
};

const TermsUpdateModal = () => {
  const { pending, acceptPending } = useLegalAcceptance();
  const [open, setOpen] = useState(true);
  const [accepting, setAccepting] = useState(false);
  const [error, setError] = useState('');

  if (!pending) return null;
  if (wasDismissed(pending.document?.id)) return null;

  const handleLater = () => {
    try { sessionStorage.setItem(dismissKey(pending.document?.id), '1'); } catch { /* privát mód */ }
    setOpen(false);
  };

  const handleAccept = async () => {
    setAccepting(true);
    setError('');
    try {
      await acceptPending();
    } catch (err) {
      setError('Az elfogadás sikertelen volt, kérjük próbálja újra.');
    } finally {
      setAccepting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleLater}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: '20px' } }}
    >
      <DialogTitle sx={{ fontFamily: 'Playfair Display', fontWeight: 700 }}>
        Frissült az Általános Szerződési Feltételek
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Frissítettük az ÁSZF-et. Kérjük, tekintse át és fogadja el a folytatáshoz. Amennyiben 8 napon belül nem fogadja el, de a fiókja továbbra is aktív marad, az ÁSZF automatikusan elfogadottnak minősül.
        </Typography>
        <Box
          sx={{
            maxHeight: 320,
            overflowY: 'auto',
            p: 2,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '10px',
            fontSize: '0.85rem',
            '& h2': { fontSize: '1rem', fontWeight: 700, color: 'primary.main', mt: 2, mb: 1 },
            '& h3': { fontSize: '0.9rem', fontWeight: 700, mt: 1.5, mb: 0.5 },
            '& p': { mb: 1 },
          }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pending.document.content) }}
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={handleLater}
          variant="outlined"
          disabled={accepting}
          sx={{ borderRadius: '10px', borderWidth: 2, '&:hover': { borderWidth: 2 } }}
        >
          Később
        </Button>
        <Button
          onClick={handleAccept}
          variant="contained"
          disabled={accepting}
          startIcon={accepting ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ borderRadius: '10px' }}
        >
          Elfogadom
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsUpdateModal;
